// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Input */

.kIy8ejVko5GJeFcy7Qx9 {
	display: flex;
    align-items: center;
	width: 100%;
	position: relative;
    border: 1px solid #CCCCCC;
    border-radius: 3px;
	z-index: 0;
}

.kIy8ejVko5GJeFcy7Qx9.sjL638wdlO3ub4ba1PTm {
	border: 0;
}

.BGzAlMQ0JntvbVz_FF4b {
	align-self: stretch;
	width: 100%;
}

.BGzAlMQ0JntvbVz_FF4b > input, .BGzAlMQ0JntvbVz_FF4b > textarea {
	width: 100%;
	height: 100%;
	min-height: 45px;
	max-height: 500px;
	max-height: 50dvh;
	margin: 0;
	padding: 10px;
    font-size: 20px;
	border: 0;
	box-sizing: border-box;
	background-color: transparent;
	outline: none;
	resize: none;
}

.kIy8ejVko5GJeFcy7Qx9.BN8mvZCA8LFTfELdIB71 {
	background-color: #EFEFEF;
}

.BGzAlMQ0JntvbVz_FF4b > input:-webkit-autofill,
.BGzAlMQ0JntvbVz_FF4b > input:-webkit-autofill:hover, 
.BGzAlMQ0JntvbVz_FF4b > input:-webkit-autofill:focus, 
.BGzAlMQ0JntvbVz_FF4b > input:-webkit-autofill:active{
	-webkit-background-clip: text;
}

.BGzAlMQ0JntvbVz_FF4b > input:focus {
	outline: none;
}

.BGzAlMQ0JntvbVz_FF4b > .qE1Fy7Ro9q4hs_UOYdcw {
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	top: 0;
	margin-left: 5px;
	height: 100%;
	color: #7A7A73;
	font-size: 1.2rem;
	z-index: -1;
	-webkit-user-select: none;
	   -moz-user-select: none;
	        user-select: none;
	transition: transform 0.3s;
}

.BGzAlMQ0JntvbVz_FF4b > textarea ~ .qE1Fy7Ro9q4hs_UOYdcw {
	max-height: 2em;
}

.BGzAlMQ0JntvbVz_FF4b > .qE1Fy7Ro9q4hs_UOYdcw::before {
	content: "";
	position: absolute;
	display: block;
	width: 100%;
	height: 5px;
	background-color: #FFFFFF;
	z-index: -1;
}

.BGzAlMQ0JntvbVz_FF4b > input:required ~ .qE1Fy7Ro9q4hs_UOYdcw::after {
	content: "*";
}

/* Date */
.BGzAlMQ0JntvbVz_FF4b > input[type="date"]::-webkit-calendar-picker-indicator {
	cursor: pointer;
	border-radius: 4px;
	margin-right: 2px;
	opacity: 0.7;
	filter: invert(0.8);
}

.BGzAlMQ0JntvbVz_FF4b > input[type="date"]::-webkit-calendar-picker-indicator:hover {
	opacity: 1
}

.BGzAlMQ0JntvbVz_FF4b > input[type="date"] ~ .qE1Fy7Ro9q4hs_UOYdcw,
.BGzAlMQ0JntvbVz_FF4b > input:focus ~ .qE1Fy7Ro9q4hs_UOYdcw,
.BGzAlMQ0JntvbVz_FF4b > textarea:focus ~ .qE1Fy7Ro9q4hs_UOYdcw,
.BGzAlMQ0JntvbVz_FF4b > input:not([value=""]) ~ .qE1Fy7Ro9q4hs_UOYdcw,
.BGzAlMQ0JntvbVz_FF4b > textarea:not(:empty) ~ .qE1Fy7Ro9q4hs_UOYdcw,
.BGzAlMQ0JntvbVz_FF4b > input:not(:empty) ~ .qE1Fy7Ro9q4hs_UOYdcw {
	transform: translate(-10%, -50%) scale(0.8);
	z-index: 0;
}

.kIy8ejVko5GJeFcy7Qx9.WssOCgihO9W_YHVdmrVd {
	border-color: #FF6D6D;
}

.kIy8ejVko5GJeFcy7Qx9.WssOCgihO9W_YHVdmrVd .qE1Fy7Ro9q4hs_UOYdcw {
	color: #FF6D6D;
}

.WssOCgihO9W_YHVdmrVd {
	color: #FF6D6D;
}`, "",{"version":3,"sources":["webpack://./src/Form/Element/style.module.css"],"names":[],"mappings":"AAAA,UAAU;;AAEV;CACC,aAAa;IACV,mBAAmB;CACtB,WAAW;CACX,kBAAkB;IACf,yBAAyB;IACzB,kBAAkB;CACrB,UAAU;AACX;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,iBAAiB;CACjB,iBAAiB;CACjB,SAAS;CACT,aAAa;IACV,eAAe;CAClB,SAAS;CACT,sBAAsB;CACtB,6BAA6B;CAC7B,aAAa;CACb,YAAY;AACb;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;;;CAIC,6BAA6B;AAC9B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,MAAM;CACN,gBAAgB;CAChB,YAAY;CACZ,cAAc;CACd,iBAAiB;CACjB,WAAW;CACX,yBAAiB;IAAjB,sBAAiB;SAAjB,iBAAiB;CACjB,0BAA0B;AAC3B;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,WAAW;CACX,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA,SAAS;AACT;CACC,eAAe;CACf,kBAAkB;CAClB,iBAAiB;CACjB,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC;AACD;;AAEA;;;;;;CAMC,2CAA2C;CAC3C,UAAU;AACX;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf","sourcesContent":["/* Input */\r\n\r\n.container {\r\n\tdisplay: flex;\r\n    align-items: center;\r\n\twidth: 100%;\r\n\tposition: relative;\r\n    border: 1px solid #CCCCCC;\r\n    border-radius: 3px;\r\n\tz-index: 0;\r\n}\r\n\r\n.container.hidden {\r\n\tborder: 0;\r\n}\r\n\r\n.element {\r\n\talign-self: stretch;\r\n\twidth: 100%;\r\n}\r\n\r\n.element > input, .element > textarea {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tmin-height: 45px;\r\n\tmax-height: 500px;\r\n\tmax-height: 50dvh;\r\n\tmargin: 0;\r\n\tpadding: 10px;\r\n    font-size: 20px;\r\n\tborder: 0;\r\n\tbox-sizing: border-box;\r\n\tbackground-color: transparent;\r\n\toutline: none;\r\n\tresize: none;\r\n}\r\n\r\n.container.disabled {\r\n\tbackground-color: #EFEFEF;\r\n}\r\n\r\n.element > input:-webkit-autofill,\r\n.element > input:-webkit-autofill:hover, \r\n.element > input:-webkit-autofill:focus, \r\n.element > input:-webkit-autofill:active{\r\n\t-webkit-background-clip: text;\r\n}\r\n\r\n.element > input:focus {\r\n\toutline: none;\r\n}\r\n\r\n.element > .placeholder {\r\n\tposition: absolute;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\ttop: 0;\r\n\tmargin-left: 5px;\r\n\theight: 100%;\r\n\tcolor: #7A7A73;\r\n\tfont-size: 1.2rem;\r\n\tz-index: -1;\r\n\tuser-select: none;\r\n\ttransition: transform 0.3s;\r\n}\r\n\r\n.element > textarea ~ .placeholder {\r\n\tmax-height: 2em;\r\n}\r\n\r\n.element > .placeholder::before {\r\n\tcontent: \"\";\r\n\tposition: absolute;\r\n\tdisplay: block;\r\n\twidth: 100%;\r\n\theight: 5px;\r\n\tbackground-color: #FFFFFF;\r\n\tz-index: -1;\r\n}\r\n\r\n.element > input:required ~ .placeholder::after {\r\n\tcontent: \"*\";\r\n}\r\n\r\n/* Date */\r\n.element > input[type=\"date\"]::-webkit-calendar-picker-indicator {\r\n\tcursor: pointer;\r\n\tborder-radius: 4px;\r\n\tmargin-right: 2px;\r\n\topacity: 0.7;\r\n\tfilter: invert(0.8);\r\n}\r\n\r\n.element > input[type=\"date\"]::-webkit-calendar-picker-indicator:hover {\r\n\topacity: 1\r\n}\r\n\r\n.element > input[type=\"date\"] ~ .placeholder,\r\n.element > input:focus ~ .placeholder,\r\n.element > textarea:focus ~ .placeholder,\r\n.element > input:not([value=\"\"]) ~ .placeholder,\r\n.element > textarea:not(:empty) ~ .placeholder,\r\n.element > input:not(:empty) ~ .placeholder {\r\n\ttransform: translate(-10%, -50%) scale(0.8);\r\n\tz-index: 0;\r\n}\r\n\r\n.container.error {\r\n\tborder-color: #FF6D6D;\r\n}\r\n\r\n.container.error .placeholder {\r\n\tcolor: #FF6D6D;\r\n}\r\n\r\n.error {\r\n\tcolor: #FF6D6D;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `kIy8ejVko5GJeFcy7Qx9`,
	"hidden": `sjL638wdlO3ub4ba1PTm`,
	"element": `BGzAlMQ0JntvbVz_FF4b`,
	"disabled": `BN8mvZCA8LFTfELdIB71`,
	"placeholder": `qE1Fy7Ro9q4hs_UOYdcw`,
	"error": `WssOCgihO9W_YHVdmrVd`
};
export default ___CSS_LOADER_EXPORT___;
